/* @ngInject */
export function hasAccess(accessRightService) {
    return {
        link: link,
        restrict: 'A',
        scope: {
            hasAccess: '@hasAccess'
        }
    };

    function link($scope, $element) {
        var accessRightString = $scope.hasAccess;
        var accessRights = accessRightString.split(',');
        accessRightService.hasAnyAccess(accessRights).then(response => {
            if(response === false){
                $element.addClass('hidden');
            }
        });
    }
}

